import { render, staticRenderFns } from "./DeviceTypesView.vue?vue&type=template&id=0588dbbe&scoped=true"
import script from "./DeviceTypesView.vue?vue&type=script&lang=ts"
export * from "./DeviceTypesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0588dbbe",
  null
  
)

export default component.exports